import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Select,
  MenuItem,
  IconButton,
  TextField,
} from "@mui/material";
import {
  LocationOn,
  Print,
  Save,

} from "@mui/icons-material";
import EventIcon from "@mui/icons-material/Event";
import PersonIcon from "@mui/icons-material/Person";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PaymentIcon from "@mui/icons-material/Payment";

import orderData from '../../../Data/orderdetails.json'; 

const OrderDetail = () => {
  return (
    <Box p={4}>
      <Typography variant="h5" fontWeight="bold">
        Order Detail
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Details for Order ID: {orderData.orderId}
      </Typography>

      <Box
        mt={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexDirection={{ xs: "column", sm: "row" }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <EventIcon color="primary" />
          <Typography variant="body2">{orderData.date}</Typography>
        </Box>
        <Box display="flex" gap={1} mt={{ xs: 2, sm: 0 }}>
          <Select defaultValue="new" size="small">
            <MenuItem value="new">Change Status</MenuItem>
            <MenuItem value="shipped">Shipped</MenuItem>
            <MenuItem value="delivered">Delivered</MenuItem>
          </Select>
          <Button
            variant="contained"
            color="success"
            startIcon={<Save />}
            sx={{
              backgroundColor: "#3bb77e",
              "&:hover": { backgroundColor: "#348d6e" },
            }}
          >
            Save
          </Button>
          <IconButton
            sx={{
              backgroundColor: "#6c757d",
              "&:hover": {
                backgroundColor: "#5a6268",
              },
              borderRadius: "10%",
            }}
          >
            <Print />
          </IconButton>
        </Box>
      </Box>

      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ boxShadow: "none" }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1}>
                <PersonIcon color="primary" />
                <Typography variant="subtitle1" fontWeight="bold">
                  Customer
                </Typography>
              </Box>
              <Typography variant="body2">{orderData.customer.name}</Typography>
              <Typography variant="body2" color="textSecondary">
                {orderData.customer.email}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {orderData.customer.phone}
              </Typography>
              <Button
                size="small"
                sx={{ color: "#3bb77e", "&:hover": { color: "#348d6e" } }}
              >
                View Profile
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ boxShadow: "none" }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1}>
                <LocalShippingIcon color="primary" />
                <Typography variant="subtitle1" fontWeight="bold">
                  Order Info
                </Typography>
              </Box>
              <Typography variant="body2">
                Shipping: {orderData.shipping.method}
              </Typography>
              <Typography variant="body2">
                Pay method: {orderData.shipping.paymentMethod}
              </Typography>
              <Typography variant="body2">
                Status: {orderData.shipping.status}
              </Typography>
              <Button
                size="small"
                sx={{ color: "#3bb77e", "&:hover": { color: "#348d6e" } }}
              >
                Download info
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ boxShadow: "none" }}>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1}>
                <LocationOn color="primary" />
                <Typography variant="subtitle1" fontWeight="bold">
                  Deliver to
                </Typography>
              </Box>
              <Typography variant="body2">{orderData.delivery.city}</Typography>
              <Typography variant="body2">
                {orderData.delivery.address}
              </Typography>
              <Typography variant="body2">{orderData.delivery.zip}</Typography>
              <Button
                size="small"
                sx={{ color: "#3bb77e", "&:hover": { color: "#348d6e" } }}
              >
                View Profile
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={3}>
        <Grid item xs={12} md={8}>
          <TableContainer component={Card} sx={{ boxShadow: "none" }}>
            <Table>
              <TableHead sx={{ backgroundColor: "#f7f8f9" }}>
                <TableRow gap={25}>
                  <TableCell sx={{ borderBottom: "none" }}>Product</TableCell>
                  <TableCell sx={{ borderBottom: "none" }}>
                    Unit Price
                  </TableCell>
                  <TableCell sx={{ borderBottom: "none" }}>Quantity</TableCell>
                  <TableCell sx={{ borderBottom: "none", textAlign: "right" }}>
                    Total
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderData.items.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ borderBottom: "none" }}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <img
                          src={require(`../../../../assests/${item.img}`)}
                          alt={item.name}
                          width={40}
                          height={40}
                        />
                        {item.name}
                      </Box>
                    </TableCell>
                    <TableCell sx={{ borderBottom: "none" }}>
                      ${item.price.toFixed(2)}
                    </TableCell>
                    <TableCell sx={{ borderBottom: "none" }}>
                      {item.quantity}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderBottom: "none",
                        textAlign: "right",
                      }}
                    >
                      ${item.total.toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))}

                <TableRow sx={{ marginBottom: 2 }}>
                  <TableCell
                    colSpan={3}
                    sx={{
                      textAlign: "right",
                      borderBottom: "none",
                      fontWeight: "bold",
                    }}
                  >
                    Subtotal:
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: "none",
                      textAlign: "right",
                    }}
                  >
                    ${orderData.subtotal.toFixed(2)}
                  </TableCell>
                </TableRow>

                <TableRow sx={{ marginBottom: 2 }}>
                  <TableCell
                    colSpan={3}
                    sx={{
                      textAlign: "right",
                      borderBottom: "none",
                      fontWeight: "bold",
                    }}
                  >
                    Shipping Cost:
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: "none",
                      textAlign: "right",
                    }}
                  >
                    ${orderData.shippingCost.toFixed(2)}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    colSpan={3}
                    sx={{
                      textAlign: "right",
                      borderBottom: "none",
                      fontWeight: "bold",
                    }}
                  >
                    <Typography variant="h6" fontWeight="bold">
                      Grand Total:
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: "none",
                      textAlign: "right",
                    }}
                  >
                    <Typography variant="h6" fontWeight="bold">
                      ${orderData.grandTotal.toFixed(2)}
                    </Typography>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    colSpan={3}
                    sx={{
                      textAlign: "right",
                      borderBottom: "none",
                      fontWeight: "bold",
                    }}
                  >
                    Status:
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: "none",
                      textAlign: "right",
                      color: "#4ecb5e",
                      padding: "6px 12px",
                      borderRadius: "4px",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        display: "inline-block",
                        backgroundColor: "rgba(78, 203, 94, 0.1)",
                        color: "#4ecb5e",
                        padding: "6px 12px",
                        borderRadius: "4px",
                        fontWeight: "bold",
                      }}
                    >
                      {orderData.status}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        <Grid item xs={12} md={4}>
          <Box sx={{ width: "100%" }}>
            <Card sx={{ boxShadow: "none", backgroundColor: "#f7f8f9" }}>
              <CardContent>
                <Box display="flex" alignItems="center" gap={1}>
                  <PaymentIcon color="error" />
                  <Typography variant="subtitle1" fontWeight="bold">
                    Payment Info
                  </Typography>
                </Box>
                <Typography variant="body2">
                  {orderData.payment.method}
                </Typography>
                <Typography variant="body2">
                  {orderData.payment.businessName}
                </Typography>
                <Typography variant="body2">
                  {orderData.payment.phone}
                </Typography>
              </CardContent>
            </Card>

            <Box mt={3}>
              <TextField
                label="Notes"
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                sx={{
                  backgroundColor: "white",
                  borderRadius: "5px",
                  padding: "10px",
                }}
              />
              <Button
                fullWidth
                variant="contained"
                sx={{
                  backgroundColor: "#3bb77e",
                  "&:hover": { backgroundColor: "#348d6e" },
                  marginTop: 2,
                }}
              >
                Notes
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderDetail;
